/**
 * uploadFile
 *
 * This calls the uploadToS3 function and commits the file params and loading status. Currently used
 * in conjunction with any file import dialogs that use AppFileImport.
 *
 * @param {Object} context
 * @param {Object} file
 * @param {Object} types
 */

import { uploadToS3 } from '~/utils/s3_uploader';

export function uploadFile(context, file, types) {
  return new Promise((resolve, reject) => {
    uploadToS3(context.$store.state.presigned_path, file, resolve, reject);
  })
    .then((response) => {
      context.$store.commit(types.SET_FILE_PARAMS, {
        id: response.fields.key.match(/cache\/(.+)$/)[1],
        storage: 'cache',
        metadata: {
          size: file.size,
          filename: file.name,
          mime_type: file.type,
        },
      });
      context.$store.commit(types.SET_UPLOAD_LOADING, false);

      return response;
    })
    .catch((e) => {
      const responseXML = e.responseXML;

      if (responseXML && responseXML.documentElement.firstChild.innerHTML === 'EntityTooLarge') {
        throw new Error('File is too large.');
      } else {
        throw new Error('Unexpected error. Please try again.');
      }
    });
}

/**
 * removeFile
 *
 * This removes a file from the store and is used in conjunction with any file import dialogs that use AppFileImport.
 *
 * @param {Object} context
 * @param {Object} types
 */

export function removeFile(context, types) {
  context.$store.commit(types.REMOVE_FILE, context.$store.state);
}
